import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-caidan",
  "use": "icon-caidan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-caidan\"><path d=\"M512.460488 65.292052c-245.843174 0-445.138196 199.295022-445.138197 445.138196s199.295022 445.138196 445.138197 445.138197 445.138196-199.295022 445.138196-445.138197-199.295022-445.138196-445.138196-445.138196z m238.430344 622.532419h-464.581014v-92.097558h464.581014v92.097558z m0-262.836197h-464.581014v-92.097558h464.581014v92.097558z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol